import React from "react";

type Props = {};

const SubTitle: React.FC<Props> = (): JSX.Element => {
  return (
    <div className="flex flex-row justify-center items-center">
      <div className="w-2 h-2 bg-bt-green mr-2 rounded-full" />
      <div className="font-nunito font-normal text-sm text-bt-green">
        Only the first name will be visible in the app
      </div>
    </div>
  );
};

export default SubTitle;
